// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1hDzn","content":"RecentSearches_content__2FI_V"};